<template>
  <v-app id="app">
    <v-app-bar app color="primary">
      <v-app-bar-nav-icon
        class="white--text"
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>

      <v-avatar
        class="ml-1"
        size="48"
        @click="$router.currentRoute.path != '/' ? $router.push('/') : null"
      >
        <img src="/LOGO_SCB_web.png" alt="Logo des SC Budokwai Garbsen e.V." />
      </v-avatar>

      <v-toolbar-title class="ml-2 white--text" @click="$router.push('/')">
        {{ $route.name }}
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn
        v-for="(social, index) in $store.state.socials"
        :key="index"
        class="ml-1"
        large
        icon
        :href="social.url"
        target="_blank"
        rel="noopener"
      >
        <v-icon large>
          {{ social.icon }}
        </v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app>
      <v-card bor>
        <v-img
          class="white--text align-end"
          max-height="125px"
          src="/Header3.jpg"
          gradient="to top right, rgba(66,66,66,.99), rgba(66,66,66,.20)"
        >
          <v-card-title class="white--text"> Judo in Garbsen </v-card-title>
          <v-card-subtitle> SC Budokwai Garbsen e.V. </v-card-subtitle>
        </v-img>
      </v-card>
      <v-divider></v-divider>
      <v-tabs vertical>
        <v-tab v-for="(tab, index) in tabs" :key="index" :to="tab.to">
          {{ tab.title }}
        </v-tab>
      </v-tabs>
    </v-navigation-drawer>
    <v-img
      ref="scroller"
      src="/logo.jpg"
      max-height="100vh"
      contain
      gradient="to top right, rgba(254,254,254,.95), rgba(254,254,254,.95)"
      class="overflow-auto"
    >
      <v-main>
        <v-fab-transition>
          <router-view />
        </v-fab-transition>
      </v-main>
    </v-img>
  </v-app>
</template>

<script>
export default {
  watch: {
    // Die Seite scrollt nicht im window, sondern im v-img-Container um
    // <v-main> (class="overflow-auto"). Deshalb greift scrollBehavior im
    // Router nicht und der Scrollstand muss beim Seitenwechsel hier
    // zurückgesetzt werden.
    $route() {
      const el = this.$refs.scroller && this.$refs.scroller.$el;
      if (el) el.scrollTop = 0;
    },
  },
  data: () => ({
    drawer: null,
    tabs: [
      { title: "Home", to: "/" },
      { title: "Trainingsplan", to: "/trainingsplan" },
      { title: "Vorstand", to: "/vorstand" },
      { title: "Beiträge & Gebühren", to: "/gebuhren" },
      { title: "Formulare", to: "/downloads" },
      { title: "Impressum", to: "/impressum" },

      //{title: "Kalender", to: "/kalender"},
    ],
  }),
};
</script>
